import { Typography, List, Space } from 'antd';
import { InfoCircleOutlined, DotChartOutlined } from '@ant-design/icons';

const { Text } = Typography;

const Leyenda = () => {
  const leyendaItems = [
    {
      title: 'Nombre:',
      description: 'Nombre unívoco del campo, se utiliza como identificador.',
    },
    {
      title: 'Longitud:',
      description: `Longitud máxima del contenido de la variable.
        Ejemplo: Si la longitud establecida es de 10, el valor ingresado en esta variable solo puede contener 10 caracteres.
        Consideraciones: Si el valor ingresado excede la longitud configurada, el sistema recortará el valor ingresado a la longitud establecida, caso contrario se completará con el caracter de relleno establecido.`,
    },
    {
      title: 'Tipo de campo:',
      description: `Tipos de campo posibles:`,
      items: [
        'Texto (campo de texto)',
        'Checkbox (casilla de verificación)',
        'Lista desplegable',
        'Tabla'
      ],
    },
    {
      title: 'Tipo de entrada:',
      description: `Tipo de dato para los campos de tipo FieldFormTextInput (campo de texto).
        Tipos de entrada posibles:`,
      items: [
        'Alfanumérico',
        'Numérico',
        'Fecha',
        'Fecha Actual',
      ],
    },
    {
      title: 'Formato de entrada:',
      description: `Tipo de formato de entrada para los campos de tipo Texto.
        Tipos de entrada:`,
      items: [
        'Mayúsculas: El valor ingresado se convertirá a mayúsculas.',
        'Minúsculas: El valor ingresado se convertirá a minúsculas.',
        'Mayúscula inicial: Se convertirá la inicial del valor ingresado a mayúscula.',
        'Entero: El valor ingresado debe ser un número entero.',
        'Decimal: El valor ingresado debe ser un número decimal.',
        'd/M/yyyy: Fecha & Fecha Actual por ejemplo: 30/1/2023',
      ],
    },
    {
      title: 'Caracter de relleno:',
      description: 'Caracter de relleno que se utilizará para completar el valor de un campo en caso de que este sea menor a la longitud establecida.',
    },
    {
      title: 'Opciones:',
      description: `Este atributo pertenece solamente al tipo de campo Lista Desplegable. Para los otros tipos de campos será null.
        Contiene un conjunto de opciones configuradas para la lista desplegable siguiendo la siguiente nomenclatura:`,
      items: [
        'Consideraciones: El numero del item comienza siempre en 0. En caso de que tengamos 3 opciones disponibles veremos las opciones de la siguiente manera:',
        '- "opcion [0]"',
        '- "opcion [1]"',
        '- "opcion [2]"',
      ],
    },
    {
      title: 'Tablas:',
      description: `Este atributo pertenece solamente al tipo de campo Tabla. Para los otros tipos de campos será null.
        Contiene un conjunto de columnas configuradas para la tabla siguiendo la siguiente nomenclatura:`,
      items: [
        'Consideraciones: El numero del item comienza siempre en 0. En caso de que tengamos 3 columnas disponibles veremos las opciones de la siguiente manera:',
        '- "columna [0]"',
        '- "columna [1]"',
        '- "columna [2]"',
      ],
    },
    {
      title: 'Descripción:',
      description: 'Descripción del campo, puede ser null.',
    },
  ];

  return (
    <div style={{
      padding: '24px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
    }}>
      {leyendaItems.map(item => (
        <div
          key={item.title}
          style={{
            marginBottom: '24px',
          }}
        >
          <Space align="start">
            <InfoCircleOutlined style={{ fontSize: '16px', color: 'orange' }} />
            <div>
              <Text
                strong
                style={{
                  color: 'orange',
                  fontWeight: 'bold',
                }}
              >
                {item.title}
              </Text>
              <br />
              <Text>{item.description}</Text>
            </div>
          </Space>
          {item.items && (
            <div style={{
              marginTop: '8px', marginLeft: '24px'
            }}>
              <List
                dataSource={item.items}
                renderItem={subItem => (
                  <List.Item>
                    <Space align="start">
                      <DotChartOutlined style={{ fontSize: '8px', color: 'orange' }} />
                      <Text>{subItem}</Text>
                    </Space>
                  </List.Item>
                )}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Leyenda;